module.exports = __webpack_public_path__ + "static/media/res3.827cef92.jpg";